import script from "./export-vies-declaration.vue?vue&type=script&setup=true&lang=ts"
export * from "./export-vies-declaration.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__